import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

// alphabetical order
import userDetail from './front/userDetail/reducer';
import paymentHistory from './front/paymentHistory/reducer';
import comment from './front/comment/reducer';
import common from './common/reducer';
import curationList from './front/curationList/reducer';
import episodeDetail from './front/episodeDetail/reducer';
import home from './front/home/reducer';
import library from './front/library/reducer';
import notices from './front/notices/reducer';
import notifications from './front/notifications/reducer';
import report from './front/report/reducer';
import search from './front/search/reducer';
import storyDetail from './front/storyDetail/reducer';
import tagDetail from './front/tagDetail/reducer';
import store from './front/store/reducer';
import watchLaterList from './front/watchLaterList/reducer';
import blockedUserList from './front/blockedUserList/reducer';
import badgeList from './front/badgeList/reducer';
import market from './front/market/reducer';
import withdrawal from './front/withdrawal/reducer';
import userList from './front/userList/reducer';
import communityPostDetail from './front/communityPostDetail/reducer';
import communityPostCreateEdit from './front/communityPostCreateEdit/reducer';
import fanClub from './front/fanClub/reducer';
import restrictionDetail from './front/restrictionDetail/reducer';
import characters from './front/characters/reducer';

// studio
import studioMyPage from './studio/myPage/reducer';
import studioStoryCreateEdit from './studio/storyCreateEdit/reducer';
import studioStoryDetail from './studio/storyDetail/reducer';
import studioEpisodeCreateEdit from './studio/episodeCreateEdit/reducer';
import studioStoryAd from './studio/storyAd/reducer';

// events
import events from './events/reducer';
import contest from './events/contest/reducer';
import consume from './events/consume/reducer';
import annualReport from './events/annualReport/reducer';

export default combineReducers({
  router: routerReducer,
  userDetail,
  paymentHistory,
  comment,
  common,
  curationList,
  episodeDetail,
  home,
  library,
  notices,
  notifications,
  report,
  search,
  storyDetail,
  tagDetail,
  characters,
  store,
  watchLaterList,
  blockedUserList,
  badgeList,
  market,
  withdrawal,
  userList,
  communityPostDetail,
  communityPostCreateEdit,
  fanClub,
  restrictionDetail,
  // studio
  studioMyPage,
  studioStoryCreateEdit,
  studioStoryDetail,
  studioEpisodeCreateEdit,
  studioStoryAd,
  // events
  events,
  contest,
  consume,
  annualReport,
});



// WEBPACK FOOTER //
// ./src/app/redux/reducers.js